import React from 'react';
import { motion } from 'framer-motion';
export const About = () => {
  return <div className="bg-white" data-id="element-286">
      <section className="py-16 md:py-24 bg-gradient-to-b from-white to-brand-light" data-id="element-287">
        <div className="container-custom" data-id="element-288">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-center max-w-3xl mx-auto" data-id="element-289">
            <h1 className="text-4xl md:text-5xl font-bold text-brand-blue mb-6" data-id="element-290">
              About Daily Serve
            </h1>
            <p className="text-xl text-gray-600" data-id="element-291">
              We're on a mission to simplify how teams work together and
              communicate with clients.
            </p>
          </motion.div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-292">
        <div className="container-custom max-w-4xl" data-id="element-293">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="mb-12" data-id="element-294">
            <h2 className="text-3xl font-bold text-brand-blue mb-4" data-id="element-295">
              Our story
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-296">
              Daily Serve was born from a simple observation: teams waste
              countless hours switching between tools, searching through emails,
              and trying to keep everyone aligned. We knew there had to be a
              better way.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-297">
              After years of working with agencies, consultancies, and service
              businesses, we built Daily Serve to be the platform we always
              wished existed—one that brings tasks, communication, and client
              collaboration into a single, intuitive workspace.
            </p>
            <p className="text-gray-600" data-id="element-298">
              Today, thousands of teams use Daily Serve to streamline their
              workflows, improve client relationships, and get more done every
              day.
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="mb-12" data-id="element-299">
            <h2 className="text-3xl font-bold text-brand-blue mb-4" data-id="element-300">
              Our values
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-301">
              <div className="bg-brand-light rounded-lg p-6" data-id="element-302">
                <h3 className="text-xl font-semibold text-brand-blue mb-2" data-id="element-303">
                  Simplicity
                </h3>
                <p className="text-gray-600" data-id="element-304">
                  We believe powerful tools should be easy to use. No
                  complicated setup, no steep learning curve.
                </p>
              </div>
              <div className="bg-brand-light rounded-lg p-6" data-id="element-305">
                <h3 className="text-xl font-semibold text-brand-blue mb-2" data-id="element-306">
                  Transparency
                </h3>
                <p className="text-gray-600" data-id="element-307">
                  Clear pricing, honest communication, and no hidden fees. What
                  you see is what you get.
                </p>
              </div>
              <div className="bg-brand-light rounded-lg p-6" data-id="element-308">
                <h3 className="text-xl font-semibold text-brand-blue mb-2" data-id="element-309">
                  Customer focus
                </h3>
                <p className="text-gray-600" data-id="element-310">
                  Your success is our success. We're constantly improving based
                  on your feedback.
                </p>
              </div>
              <div className="bg-brand-light rounded-lg p-6" data-id="element-311">
                <h3 className="text-xl font-semibold text-brand-blue mb-2" data-id="element-312">
                  Reliability
                </h3>
                <p className="text-gray-600" data-id="element-313">
                  Your work is important. We ensure Daily Serve is always
                  available when you need it.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
};